import { collection, getDocs } from '@firebase/firestore';
import { firestoreDb } from 'src/constants';

export async function getBusinessesNames(): Promise<
  { id: string; name: string }[]
> {
  try {
    const snapshot = await getDocs(collection(firestoreDb, 'businesses'));
    return snapshot.docs.map((doc) => {
      const data = doc.data() as { name?: string };
      return { id: doc.id, name: data.name ?? '' };
    });
  } catch (e) {
    console.error(e);
    return [];
  }
}
